export const SET_GLOBAL_TOAST_VISIBLE = 'SET_GLOBAL_TOAST_VISIBLE';
export const SET_GLOBAL_TOAST_TEXT = 'SET_GLOBAL_TOAST_TEXT';
export const SET_SHOW_SIDEBAR = 'SET_SHOW_SIDEBAR';
export const SET_SHOW_NOTIFICATION = 'SET_SHOW_NOTIFICATION';
export const SET_NOTIFICATION_LIST = 'SET_NOTIFICATION_LIST';
